module.exports = __webpack_public_path__ + "img/closed.7eec5266.svg";